module.exports = __webpack_public_path__ + "static/media/ArrowLeftDisabled.c3422027.svg";